module.exports = __webpack_public_path__ + "static/media/marker_my_location.b6784fbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_my_location.svg
// module id = 237
// module chunks = 0